import React from "react";
import styles from "./MissionSection.module.css";

function MissionSection() {
    return (
        <section className={styles.missionSection}>
            <div className={styles.missionCard}>
                <p className={styles.topP}>Our Mission</p>
                <h3>Democratizing concierge services for everyone.</h3>
                <p className={styles.bottomP}>We believe that everyone deserves access to reliable, high-quality assistance — whether you're a startup founder juggling a hundred tasks or a parent trying to plan the perfect birthday party. <br />
                    Our platform connects you with vetted professionals who handle the details so you can focus on what matters most.</p>
            </div>

            <div className={styles.generalCard}>

                <div className={styles.client}>
                    <div className={styles.imgContainer}><img src="./images/profile.svg" alt="person" /></div>
                    
                    <div className={styles.cardInfo}>
                        <p className={styles.top}>For Clients</p>
                        <p className={styles.bottom}>Browse, request, and track services from your phone or laptop.</p>
                    </div>
                </div>
                
                <div className={styles.vendor}>
                    <div className={styles.imgContainer}><img src="./images/badge.svg" alt="badge" /></div>

                    <div className={styles.cardInfo}>
                        <p className={styles.top}>For Vendors</p>
                        <p className={styles.bottom}>Grow your business with a steady stream of verified service requests.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MissionSection